/** Derive the API base URL from the current hostname. */
export function getApiBaseUrl(): string {
  const hostname = window.location.hostname;
  if (hostname.includes("bpmlaw")) return "https://hourglassapi.bpmlaw.com";
  if (hostname.includes("tysonmendes")) return "https://hourglassapi.tysonmendes.com";
  if (hostname.includes("pregodonnell")) return "https://hourglassapi.pregodonnell.com";
  if (hostname.includes("localhost")) return "http://localhost:8000";
  if (hostname.includes("app")) return "https://api.hourglass.law";
  const subdomain = hostname.split(".")[0];
  return `https://${subdomain}api.hourglass.law`;
}
